import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UnitGroupModel} from '../../../unit/unit-group/unit-group.model';
import {RouteLibraryEntities} from '../../../route/route-library-entity';
import {RouteLibraryService} from '../../../route/route-library.service';
import {ModalWindowType} from '../../../shared/modal-window/modal-window-type';
import {take} from 'rxjs/operators';
import {ModalWindowService} from '../../../shared/modal-window/modal-window.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-unit-group-item',
  templateUrl: './unit-group-item.component.html',
  styleUrls: ['./unit-group-item.component.scss']
})
export class UnitGroupItemComponent implements OnInit {

  public readonly RouteLibraryEntities = RouteLibraryEntities;
  @Input() unitGroup: UnitGroupModel;
  @Output() deleteConfirmed: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(
    public routeLibrary: RouteLibraryService,
    private modalWindowService: ModalWindowService,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
  }

  delete() {
    this.modalWindowService.showWindow({
      modalWindowType: ModalWindowType.Confirmation,
      text: this.translate.instant('Are you sure you want to remove unit from this group?')
    }).pipe(
      take(1)
    ).subscribe(result => {
      if (result.confirmed) {
        this.deleteConfirmed.emit(true);
      }
    });
  }
}
